import Link from "next/link"

export const outlineButtonTw =
    "border border-darkGrey bg-transparent font-display text-darkGrey py-2 px-4 hover:scale-105 transition-all active:scale-100"

export function OutlinedButton({ link, label }: { link: string; label: string }) {
    const tw = `${outlineButtonTw} no-underline hover:no-underline`

    if (link.startsWith("http")) {
        return (
            <a href={link} target="_blank" rel="noopener noreferrer" className={tw}>
                {label}
            </a>
        )
    }
    return (
        <Link href={link} className={tw}>
            {label}
        </Link>
    )
}

export function Button({ link, label, backgroundColor, accentColor }: { backgroundColor?: string, accentColor?: string, link: string, label: string }) {
    if (!link) return null;

    const tw = "bg-black font-display text-white py-2 px-4 hover:scale-105 transition-all active:scale-100"

    if (link.startsWith("http")) {
        return (
            <a href={link} target="_blank" style={{
                backgroundColor: accentColor,
                color: backgroundColor,
                textDecoration: 'none'
            }} rel="noopener noreferrer" className={tw}>
                {label}
            </a>
        )
    } else {
        return (
            <Link href={link} style={{
                backgroundColor: accentColor,
                color: backgroundColor,
                textDecoration: 'none'
            }} className={tw}>
                {label}
            </Link>
        )
    }
}